module.exports = __webpack_public_path__ + "media/2_1.ac7319a3.wav";